import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withProps } from 'recompose';

import { Paragraph, Text } from 'components/core/Typography';
import { Card } from 'components/legacy/Card';

import buildStorageStats from 'utils/search/buildStorageStats';

import './StorageStats.scss';

export const enhance = withProps(({ pricingStats }) => ({
	lowPrices: buildStorageStats(pricingStats.lowestPrices),
	avgPrices: buildStorageStats(pricingStats.averagePrices)
}));

export function StorageStats({ city, lowPrices, avgPrices, facilityCount }) {
	return (
		<Card className="storage-stats">
			<div className="card-content">
				<table>
					<tbody>
						<tr>
							<th>
								<Paragraph className="header" size="small" last>
									{city} Storage Stats
								</Paragraph>
							</th>
						</tr>
						<tr>
							<td>
								<Paragraph className="active-facilities" size="small" last>
									Active Facilities:
									{' '}
									<Text className="stat-description" color="blue" last>{facilityCount}</Text>
								</Paragraph>
							</td>
						</tr>
						{!!avgPrices.length &&
							<Fragment>
								<tr>
									<td>
										<Paragraph size="small" className="sub-title" last>
											Average Unit Prices
										</Paragraph>
									</td>
								</tr>
								{
									avgPrices.map(({ price, size }) => (
										<tr key={size}>
											<td>
												<Paragraph className="stat" last>
													<Text className="stat stat-description" color="blue" last>
														{size}
													</Text>
													{' '}
													= {price}
												</Paragraph>
											</td>
										</tr>
									))
								}
							</Fragment>
						}
						{!!lowPrices.length &&
							<Fragment>
								<tr>
									<td>
										<Paragraph size="small" className="sub-title" last>
											Lowest Unit Prices
										</Paragraph>
									</td>
								</tr>
								{
									lowPrices.map(({ price, size }) => (
										<tr key={size}>
											<td>
												<Paragraph className="stat" last>
													<Text className="stat stat-description" color="blue" last>
														{size}
													</Text>
													{' '}
													= {price}
												</Paragraph>
											</td>
										</tr>
									))
								}
							</Fragment>
						}
					</tbody>
				</table>
			</div>
		</Card>
	);
}

StorageStats.propTypes = {
	city: PropTypes.string.isRequired,
	lowPrices: PropTypes.arrayOf(PropTypes.object).isRequired,
	avgPrices: PropTypes.arrayOf(PropTypes.object).isRequired,
	facilityCount: PropTypes.number.isRequired
};

export default enhance(StorageStats);
